import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { RootNavParamList } from '../../../App';
import { NavigationWithProps } from '../../core/Types';
import AuthorizationStep from './steps/AuthorizationStep';
import SignUpEmailStep from './steps/SignUpEmailStep';
import LoginEmailStep from './steps/LoginEmailStep';
import PasswordRestoreStep from './steps/PasswordRestoreStep';

export type LoginNavParamList = {
    "Authorization": {
        therapistId?: number;
        clinicId?: number;
    } | undefined,
    "LoginEmail": {
        email: string;

        therapistId?: number;
        clinicId?: number;
    },
    "PasswordRestore": {
        therapistId?: number;
        clinicId?: number;

        email: string;
    },
    "SignUpEmail": {
        therapistId?: number;
        clinicId?: number;

        email?: string;
        verif?: string;
    }
};

const Stack = createNativeStackNavigator<LoginNavParamList>();
const Login: React.FC<NavigationWithProps<{}, RootNavParamList, "Login">> = ({ navigation, route }) => {

    const { therapistId, clinicId } = route.params || {};

    console.log("Login navigator params:", route.params);

    return (
        <Stack.Navigator id='LoginNavigator' initialRouteName='Authorization' screenOptions={{
            headerShown: false
        }}>
            <Stack.Screen name="Authorization" component={AuthorizationStep} initialParams={{ therapistId, clinicId }} />
            <Stack.Screen name="LoginEmail" component={LoginEmailStep} initialParams={{ therapistId, clinicId }} />
            <Stack.Screen name="PasswordRestore" component={PasswordRestoreStep} initialParams={{ therapistId, clinicId }} />
            <Stack.Screen name="SignUpEmail" component={SignUpEmailStep} initialParams={{ therapistId, clinicId }} />
        </Stack.Navigator>
    );
}

export default Login;
